import styled from 'styled-components'

import { ModalText } from '../../components/Typography'
import { fontWeight, color, fontFamily } from '../../styles'

import { fontSize } from 'src/styles/fonts'
import { media } from 'src/styles/media'

export const Wrap = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 100%;
  margin: 0;
  padding: 3rem;
  background-image: linear-gradient(238deg, #fffdee 100%, #fef7e2);
`

export const StyledForm = styled.form`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;

  ${media.desktop} {
    max-width: 47.5rem;
    margin: 4.8rem 0 8rem 0;
  }

  label {
    margin-bottom: 0.8rem;
  }

  button {
    align-self: center;
    margin-top: 8rem;
  }
`

type InputProps = {
  isError: boolean
}

export const StyledInput = styled.input<InputProps>`
  height: 4.8rem;
  border-radius: 0.6rem;
  background-color: ${color.WHITE};
  border: solid 0.1rem
    ${({ isError }) => (isError ? `${color.ORANGEY_RED}` : `${color.WHITE}`)};
  padding-left: 1.6rem;
  font-size: ${fontSize.NORMAL};
  line-height: 4.8rem;
  color: ${color.GREYISH_BROWN};
  font-family: ${fontFamily.CATAMARAN};
  width: 100%;
  -webkit-appearance: none;

  ::placeholder {
    font-size: ${fontSize.NORMAL};
    color: ${color.PUTTY};
  }

  ${media.desktop} {
    width: 47.5rem;
  }
`

export const ToPhone = styled(ModalText)`
  font-weight: ${fontWeight.SEMI};
  margin-top: 4rem;
`

export const FooterWrap = styled.div`
  margin-top: 3rem;
`
